import Vue from "vue";
import Router from "vue-router";
import TokenManager from "./managers/TokenManager";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      beforeEnter: (to, from, next) => {
        TokenManager.getAdfsToken() === "" ? next("login") : next();
      },
      component: () =>
        import(/* webpackChunkName: "navbar" */ "./components/NavBar.vue"),
      children: [
        {
          path: "users",
          name: "users",
          component: () =>
            import(/* webpackChunkName: "users" */ "./views/AdminUserPage.vue")
        },
        {
          path: "myprofile",
          name: "myprofile",
          component: () =>
            import(/* webpackChunkName: "myprofile" */ "./views/MyProfile.vue")
        },
        {
          path: "customers",
          name: "customers",
          component: () =>
            import(
              /* webpackChunkName: "customers" */ "./views/CustomerPage.vue"
            ),
          children: [
            {
              path: ":id",
              name: "customers-deatil",
              component: () =>
                import(
                  /* webpackChunkName: "CustomerDetail" */ "./components/CustomerDetail.vue"
                )
            }
          ]
        },
        {
          path: "prospects",
          name: "prospects",
          component: () =>
            import(
              /* webpackChunkName: "prospects" */ "./views/ProspectCustomerPage.vue"
            )
        },
        {
          path: "devices",
          name: "devices",
          component: () =>
            import(/* webpackChunkName: "devices" */ "./views/DevicePage.vue")
        },
        {
          path: "register",
          name: "register",
          component: () =>
            import(
              /* webpackChunkName: "register" */ "./views/RegisterPage.vue"
            )
        },
        {
          path: "poc",
          name: "poc",
          component: () =>
            import(/* webpackChunkName: "poc" */ "./views/PocPage.vue")
        },
        {
          path: "",
          name: "home",
          component: () =>
            import(/* webpackChunkName: "home" */ "./views/HomePage.vue")
        }
      ]
    },
    {
      path: "/login",
      name: "login",
      component: () =>
        import(/* webpackChunkName: "login" */ "./views/LoginPage.vue")
    },
    {
      path: "/success",
      name: "login-success",
      component: () =>
        import(
          /* webpackChunkName: "login-success" */ "./views/login_response/LoginSuccessPage.vue"
        )
    },
    {
      path: "/error",
      name: "login-fail",
      component: () =>
        import(
          /* webpackChunkName: "login-failed" */ "./views/login_response/LoginFailPage.vue"
        )
    },
    {
      path: "*",
      name: "page-not-found",
      component: () =>
        import(
          /* webpackChunkName: "page-not-found" */ "./views/NotFoundPage.vue"
        )
    }
  ]
});
